<template>
  <div class="col-12">
    <div class="row">
      <div class="col-12 pt-0 px-0">
        <div class="col-12 py-1 px-4">
          <h3 class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"></h3>
          <div class="row">
            <div class="form-group col-12 col-md-8 mb-0 mb-md-4 px-0">
              <div class="d-flex align-items-end">
                <div class="w-50 pr-2" v-if="!id_user_contract">
                  <label for="">Búsqueda</label>
                  <input
                    type="text"
                    placeholder="Buscar"
                    class="form-control form-control-sm mt-1 mb-2"
                    v-model="searchQuery"
                    @keyup="loadElements(1, id_user_contract)"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-md-4 p-0 mb-3 pt-md-4">
              <div class="d-flex justify-content-md-end pt-md-2 pt-0">
                <button
                  type="button"
                  class="bg-primary text-white font-weight-normal border btn-outline-primary h5 mb-0 btn"
                  @click.prevent="goNew()"
                >
                  Agregar carta de agremiado
                </button>
              </div>
            </div>
          </div>

          <div class="table-responsive card">
            <table class="table table-sm table-hover">
              <thead class="thead-light">
                <tr>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">id</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Agremiado</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Usuario</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Empresa</div>
                  </th>
                  <th class="" scope="col">
                    <div class="font-weight-bold text-center">Documento</div>
                  </th>
                  <th class="mb-0" scope="col">
                    <div class="font-weight-bold text-center">Acciones</div>
                  </th>
                  <th class="d-none"></th>
                </tr>
              </thead>
              <tbody class=" ">
                <tr
                  class=""
                  v-for="item in data"
                  :key="item.id"
                  style="cursor: pointer; height: 38px"
                >
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">
                    {{ item.user.first_name + ' ' + item.user.last_name }}
                  </td>
                  <td class="text-center">
                    {{ item.user.email }}
                  </td>
                  <td class="text-center">{{ item.company_name }}</td>
                  <td class="text-center">
                    {{ item.title }}
                  </td>
                  <td class="text-center">
                    <div class="d-flex justify-content-center w-100">
                      <Tooltip text="Ver">
                        <button
                          class="btn bg-primary d-flex justify-content-center align-items-center border-0 mr-1 border-0 p-2"
                          @click.prevent="openFile(item.url_image)"
                        >
                          <i
                            class="text-white bi bi-eye-fill d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip
                        :text="item.active === 1 ? 'Desactivar' : 'Activar'"
                      >
                        <button
                          class="btn border-0 mx-1 p-2"
                          :class="{
                            'bg-secondary': item.active === 0,
                            'bg-success': item.active === 1
                          }"
                          @click="changeStatus(item.id, item.active)"
                        >
                          <i
                            v-if="item.active === 1"
                            class="bi bi-check2-circle text-white d-flex justify-content-center align-items-center"
                          ></i>
                          <i
                            v-else
                            class="bi bi-eye-slash text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip text="Editar">
                        <button
                          class="btn bg-warning d-flex justify-content-center align-items-center border-0 ml-1 p-2 mr-1"
                          @click.prevent="openEditModal(item)"
                        >
                          <i
                            class="bi bi-pencil-square text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                      <Tooltip text="Eliminar">
                        <button
                          class="btn bg-danger border-0 p-2 ml-1 h-100"
                          @click="changeStatus(item.id, item.active, true)"
                        >
                          <i
                            class="bi-trash3-fill text-white d-flex justify-content-center align-items-center"
                          ></i>
                        </button>
                      </Tooltip>
                    </div>
                  </td>
                  <td class="d-none"></td>
                </tr>
              </tbody>
            </table>
            <!--Paginacion-->
            <div class="d-flex justify-content-center" v-if="!id_user_contract">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === 1 }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage - 1)"
                      aria-label="Previous"
                    >
                      <span aria-hidden="true">&laquo;</span>
                    </a>
                  </li>
                  <li class="page-item" v-for="page in totalPages" :key="page">
                    <a
                      class="page-link"
                      :class="{
                        'bg-primary ': page == currentPage,
                        'text-white': page === currentPage
                      }"
                      href="#"
                      @click.prevent="changePage(page)"
                      >{{ page }}</a
                    >
                  </li>
                  <li
                    class="page-item"
                    :class="{ disabled: currentPage === totalPages }"
                  >
                    <a
                      class="page-link"
                      href="#"
                      @click.prevent="changePage(currentPage + 1)"
                      aria-label="Next"
                    >
                      <span aria-hidden="true">&raquo;</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showEditModal" class="modal-overlay" @click.self="closeModal()">
      <div
        class="modal-content p-4 zoom-in shadow-lg rounded-lg border-0"
        style="max-height: 75%; width: auto; overflow: visible !important"
      >
        <div
          class="card p-2 justify-content-around w-100 m-auto pl-0 pr-0"
          style="
            width: 100%;
            max-width: 500px;
            min-width: 300px;
            border-style: dashed !important;
            border-width: 4px !important;
          "
        >
          <div class="rounded-top">
            <file-pond
              name="document"
              ref="filePondEdit"
              label-idle="<i class='bi bi-cloud-upload'></i> Agrega un documento"
              accepted-file-types="image/jpeg, image/png, application/pdf"
              v-if="!isEditing"
            />
            <file-pond
              name="document"
              ref="filePondEdit"
              label-idle="Reemplazar documento"
              accepted-file-types="image/jpeg, image/png, application/pdf"
              v-if="isEditing"
            />
          </div>
          <div class="rounded-top p-3">
            <label v-if="!isEditing">Empresa Agremiada:</label>
            <Multiselect
              v-if="!isEditing"
              v-model="user"
              :options="users"
              label="company_name"
              placeholder="Selecciona una empresa"
              required
            />
            <label v-if="isEditing"
              >Agremiado: <b> {{ documentEdit.user.email }}</b></label
            ><br />
            <label>Documento:</label>
            <Multiselect
              v-model="contract"
              :options="contracts"
              label="title"
              placeholder="Selecciona un documento"
              required
            />
          </div>
          <div class="rounded-bottom p-3 text-center">
            <button
              @click.prevent="saveDocument()"
              class="btn btn-primary w-100"
            >
              {{ isEditing ? 'Guardar Cambios' : 'Agregar Documento' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Swal from 'sweetalert2'

export default {
  components: {
    Multiselect
  },
  props: ['id_user_contract'],
  data() {
    return {
      showEditModal: false,
      isEditing: false,
      data: [],
      searchQuery: '',
      currentPage: 1,
      totalPages: 0,
      limit: 20,
      user: '',
      users: [],
      contract: '',
      contracts: [],
      documentEdit: {
        id: null,
        title: '',
        url_image: ''
      }
    }
  },
  methods: {
    ...mapActions([
      'getData',
      'createData',
      'updateData',
      'changeStatusData',
      'optimizeImage'
    ]),

    async loadElements(page = 1, id_user_contract = null) {
      const form = {
        url: 'user_contract/all',
        params: {
          query: this.searchQuery,
          page: page,
          limit: this.limit,
          id_user: id_user_contract
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.data = response.data.data
            // agrega en cada elemento de data la empresa del usuario desde this.users, pero como data ya tiene el usuario, vas a crear una propiedad llamada company_name en cada elemento de data
            this.data.forEach((element) => {
              element.company_name = this.users.find(
                (user) => user.id_user === element.id_user
              ).company_name
            })
            this.currentPage = response.data.meta.current_page
            this.totalPages = response.data.meta.last_page
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadContracts() {
      const form = {
        url: 'contract_template/all',
        status: 1
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.contracts = response.data.map((contract) => ({
              id: contract.id,
              title: contract.title
            }))
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },
    async loadCompanys(id_user_contract = null) {
      let form = {
        url: 'user/all',
        params: {
          active: 1
        }
      }

      if (id_user_contract) {
        form = {
          url: 'user/' + id_user_contract
        }
      }

      await this.getData(form)
        .then((response) => {
          if (response.code === 200) {
            this.users = id_user_contract
              ? [
                  {
                    id_user: response.data.id,
                    id_company: response.data.company.id,
                    company_name: response.data.company.company_name
                  }
                ]
              : response.data
                  .filter((user) => user.company && user.id_company !== 0)
                  .map((user) => ({
                    id_user: user.id,
                    id_company: user.company.id,
                    company_name: user.company.company_name
                  }))
            console.log('id_user_contract:', id_user_contract)
            console.log('USERS', this.users)
            if (id_user_contract) {
              this.user = this.users[0]
            } else {
              this.user = this.users.filter(
                (user) => user.id_user == this.id_user_contract
              )
            }
          }
        })
        .catch((error) => {
          console.error(error)
        })
    },

    async goNew() {
      await this.resetModal()
      this.showEditModal = true
      this.loadCompanys(this.id_user_contract)
    },

    async openEditModal(item) {
      await this.resetModal()
      this.isEditing = true

      this.documentEdit = { ...item }
      this.contract = {
        id: item.contract_template.id,
        title: item.contract_template.title
      }
      this.showEditModal = true
    },

    resetModal() {
      this.isEditing = false
      this.documentEdit = { title: '', url_image: '' }
      this.user = ''
      this.$refs.filePondEdit && this.$refs.filePondEdit.clear() // Limpiar archivo
    },

    closeModal() {
      this.showEditModal = false
      this.isEditing = false
      this.documentEdit = {}
    },

    saveDocument() {
      if (this.isEditing) {
        this.updateDocument()
      } else {
        this.addDocument()
      }
    },

    async addDocument() {
      const formData = new FormData()
      formData.append('title', this.contract.title)
      const filePondInstance = this.$refs.filePondEdit.getFiles()
      if (!filePondInstance.length) {
        Swal.fire('Error', 'No se ha seleccionado ningún archivo.', 'error')
        return
      }
      const compressedImage = await this.optimizeImage(filePondInstance[0].file)
      formData.append('url_image', compressedImage)
      formData.append('id_contract_template', this.contract.id)
      formData.append('id_user', this.user.id_user)

      const form = {
        url: 'user_contract/save',
        data: formData
      }

      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Se añadirá el nuevo documento.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, agregar',
        cancelButtonText: 'Cancelar'
      })

      if (result.isConfirmed) {
        await this.createData(form)
          .then((response) => {
            if (response.code === 200) {
              Swal.fire('¡Éxito!', 'El documento ha sido agregado.', 'success')
              this.loadElements(1, this.id_user_contract)
              this.closeModal()
            }
          })
          .catch((error) => {
            Swal.fire(
              'Error',
              'Hubo un problema al agregar el documento.',
              'error'
            )
            console.error(error)
          })
      }
    },

    async updateDocument() {
      const formData = new FormData()
      formData.append('title', this.contract.title)
      const filePondInstance = this.$refs.filePondEdit.getFiles()
      if (!filePondInstance.length) {
        Swal.fire('Error', 'No se ha seleccionado ningún archivo.', 'error')
        return
      }
      const compressedImage = await this.optimizeImage(filePondInstance[0].file)
      formData.append('url_image', compressedImage)
      formData.append('id_contract_template', this.contract.id)

      const form = {
        url: 'user_contract/update',
        id: this.documentEdit.id,
        data: formData
      }

      const result = await Swal.fire({
        title: '¿Estás seguro?',
        text: 'Se actualizará el documento.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, actualizar',
        cancelButtonText: 'Cancelar'
      })

      if (result.isConfirmed) {
        await this.updateData(form)
          .then((response) => {
            if (response.code === 200) {
              Swal.fire(
                '¡Éxito!',
                'El documento ha sido actualizado.',
                'success'
              )
              this.loadElements()
              this.closeModal()
            }
          })
          .catch((error) => {
            Swal.fire(
              'Error',
              'Hubo un problema al actualizar el documento.',
              'error'
            )
            console.error(error)
          })
      }
    },
    openFile(url) {
      window.open(url, '_blank')
    },

    changeStatus(id, active, isDelete = false) {
      let status
      let message

      if (isDelete) {
        status = 2
        message = '¿Estás seguro de eliminar el documento?'
      } else {
        status = active === 0 ? 1 : 0
        message =
          active === 0
            ? '¿Estás seguro de activar el documento?'
            : '¿Estás seguro de desactivar el documento?'
      }

      const form = {
        url: 'user_contract/change_status',
        id,
        status
      }

      Swal.fire({
        title: 'Advertencia',
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, continuar!'
      }).then(async (result) => {
        if (result.isConfirmed) {
          await this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200 && status === 0) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del documento ha sido desactivado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 1) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El estado del documento ha sido activado'
                })
                this.loadElements()
              } else if (response.code === 200 && status === 2) {
                Swal.fire({
                  icon: 'success',
                  title: '¡Éxito!',
                  text: 'El documento ha sido eliminado'
                })
                this.loadElements()
              }
            })
            .catch((error) => {
              console.error(error)
            })
        }
      })
    }
  },

  async mounted() {
    if (this.id_user_contract) {
      console.log('ID USER CONTRACT', this.id_user_contract)
      await this.loadCompanys(this.$route.params.id)
      console.log('COMPANYS', this.users)

      await this.loadElements(1, this.$route.params.id)
      await this.loadContracts()
      console.log('USER', this.user)
    } else {
      console.log('NO ID USER CONTRACT')
      await this.loadCompanys()
      await this.loadElements(1)
      await this.loadContracts()
    }
  }
}
</script>
<style>
@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.zoom-in {
  animation: zoomIn 0.2s ease-in-out; /* Duración de 0.5s, ajustable */
}
</style>
